import { render, staticRenderFns } from "./QuestionGroupList.vue?vue&type=template&id=c63f44a2&scoped=true&"
import script from "./QuestionGroupList.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f44a2",
  null
  
)

export default component.exports